var exports = {
  "k": "xf61da738--204edf--container",
  "X": "xf61da738--204edf--scroller",
};

module.exports = exports;
